(() => {
  const element = document.getElementById('ae-plant-care-config');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const mobile = window.matchMedia('(max-width: 749px)');
  const preview = config.environment === 'preview';
  const isEligible = () => config.productHandle === 'echinodorus-bleheri-amazon-sword' && mobile.matches;
  const key = `ae_pc_assignment_v1_${config.environment}`;
  const duration = 90 * 24 * 60 * 60 * 1000;
  const attributionDuration = 7 * 24 * 60 * 60 * 1000;
  const params = new URLSearchParams(location.search);
  const forced = preview && ['control', 'treatment'].includes(params.get('ae_pc_arm')) ? params.get('ae_pc_arm') : null;
  const status = { environment: config.environment, consent: 'waiting', arm: preview ? (forced || 'treatment') : 'control', attribution: 'not_started', transport: 'waiting', events: [] };
  let assignment = null;
  let busy = false;
  let rerun = false;
  let enrolled = false;
  let viewObserver;
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const valid = (record) => record && record.experiment === config.experiment && record.environment === config.environment && ['control', 'treatment'].includes(record.arm) && typeof record.participant === 'string' && Number.isFinite(record.enrolledAt) && record.expiresAt > Date.now();
  const render = () => {
    status.eligible = isEligible();
    status.privacyCheck = typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed;
    status.eventPublisher = typeof window.Shopify?.analytics?.publish;
    element.dataset.consent = status.consent;
    element.dataset.arm = status.arm;
    element.dataset.attribution = status.attribution;
    element.dataset.transport = status.transport;
    let panel = document.getElementById('ae-plant-care-debug');
    if (preview && params.get('ae_pc_debug') === '1') {
      if (!panel) {
        panel = document.createElement('details');
        panel.id = 'ae-plant-care-debug';
        panel.open = true;
        panel.style.cssText = 'position:fixed;bottom:48px;left:8px;right:8px;z-index:99999;max-height:210px;overflow:auto;background:#fff;border:1px solid #798c45;padding:8px;font:12px/1.4 sans-serif;color:#212326';
        const summary = document.createElement('summary');
        summary.textContent = 'Plant-care tracking — preview only';
        panel.appendChild(summary);
        panel.appendChild(document.createElement('pre'));
        for (const [label, analytics] of [['Allow analytics for QA', true], ['Turn analytics off', false]]) {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = label;
          button.addEventListener('click', () => {
            const privacy = window.Shopify?.customerPrivacy;
            status.consentWrite = 'requested';
            render();
            if (typeof privacy?.setTrackingConsent !== 'function') {
              status.consentWrite = 'api_unavailable'; render(); return;
            }
            privacy.setTrackingConsent({ analytics }, () => {
              status.consentWrite = 'callback_received'; start();
            });
          });
          panel.appendChild(button);
        }
        document.body.appendChild(panel);
      }
      panel.querySelector('pre').textContent = JSON.stringify(status, null, 2);
    }
  };
  const notify = () => {
    render();
    document.dispatchEvent(new CustomEvent('ae:plant-care-assignment', { detail: { arm: status.arm } }));
  };
  const publish = async (name, extra = {}) => {
    if (!assignment || !allowed()) return false;
    const payload = { ...assignment, themeId: config.themeId, ...extra };
    try {
      if (typeof window.Shopify?.analytics?.publish !== 'function') {
        status.transport = 'shopify_publish_unavailable';
        render();
        return false;
      }
      const accepted = await window.Shopify.analytics.publish(`ae_plant_care:${name}`, payload);
      status.transport = accepted === false ? 'not_accepted' : 'published_to_shopify';
      status.events.push(`${name}: ${status.transport}`);
      status.events = status.events.slice(-8);
      render();
      return accepted !== false;
    } catch {
      status.transport = 'publish_failed';
      render();
      return false;
    }
  };
  const tagCart = async () => {
    if (!assignment || !allowed()) return false;
    const attribute = preview ? 'ae_pc_preview__' : 'ae_pc_assignment__';
    status.attribution = 'saving';
    render();
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { [attribute]: JSON.stringify(assignment) } }),
      });
      if (!response.ok) throw new Error('cart attribution failed');
      status.attribution = 'saved_private_cart_attribute';
      render();
      return true;
    } catch {
      status.attribution = 'save_failed';
      render();
      return false;
    }
  };
  const observe = () => {
    if (!isEligible() || !assignment || !allowed()) return;
    const list = document.querySelector('.Avada-Fbt__ProductList');
    if (!list || list.dataset.aePcObserved === assignment.participant) return;
    list.dataset.aePcObserved = assignment.participant;
    viewObserver?.disconnect();
    viewObserver = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return;
      viewObserver.disconnect();
      publish('recommendation_view');
    }, { threshold: 0.25 });
    viewObserver.observe(list);
  };
  const start = async () => {
    if (busy) { rerun = true; return; }
    status.consent = allowed() ? 'analytics_allowed' : 'analytics_not_allowed';
    if (!allowed()) {
      const previouslyAssigned = assignment !== null;
      assignment = null;
      enrolled = false;
      viewObserver?.disconnect();
      if (!preview) status.arm = 'control';
      try { localStorage.removeItem(key); } catch {}
      if (previouslyAssigned) {
        const attribute = preview ? 'ae_pc_preview__' : 'ae_pc_assignment__';
        fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [attribute]: '' } }),
        }).catch(() => {});
        status.attribution = 'revoked';
      }
      notify();
      return;
    }
    busy = true;
    try {
      let saved;
      try { saved = JSON.parse(localStorage.getItem(key)); } catch {}
      if (valid(saved) && (!forced || saved.arm === forced)) assignment = saved;
      else if (isEligible()) {
        const random = crypto.getRandomValues(new Uint32Array(1))[0];
        assignment = { experiment: config.experiment, environment: config.environment,
          participant: crypto.randomUUID(), arm: preview ? (forced || 'treatment') : (random < 2147483648 ? 'control' : 'treatment'),
          enrolledAt: Date.now(), expiresAt: Date.now() + duration };
        assignment.attributionExpiresAt = assignment.enrolledAt + attributionDuration;
        localStorage.setItem(key, JSON.stringify(assignment));
      }
      if (!assignment) { notify(); return; }
      status.arm = assignment.arm;
      notify();
      await tagCart();
      if (isEligible() && !enrolled) enrolled = await publish('enrolled');
      observe();
    } catch {
      assignment = null;
      status.attribution = 'assignment_storage_failed';
      if (!preview) status.arm = 'control';
      notify();
    } finally {
      busy = false;
      if (rerun) { rerun = false; start(); }
    }
  };
  document.addEventListener('visitorConsentCollected', start);
  mobile.addEventListener('change', start);
  document.addEventListener('click', (event) => {
    if (!assignment || !allowed() || !(event.target instanceof Element)) return;
    const checkbox = event.target.closest('.Avada-OfferItem.-fbt [role="checkbox"]');
    const row = checkbox?.closest('.Avada-OfferItem.-fbt');
    if (row?.querySelector('a[href*="/products/neutro-terratabs-15-pieces"]')) {
      setTimeout(() => publish('root_tabs_selection', { selected: checkbox.getAttribute('aria-checked') === 'true' }), 0);
    }
    if (event.target.closest('.Avada-Offer__ButtonAddToCart')) publish('bundle_add_click');
    if (event.target.closest('button[name="checkout"], .cart__checkout-button')) publish('checkout_click');
  }, true);
  new MutationObserver(observe).observe(document.getElementById('MainContent'), { childList: true, subtree: true });
  render();
  if (window.Shopify?.customerPrivacy) start();
  else if (typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) { status.consent = 'privacy_api_failed'; render(); }
      else start();
    });
  } else { status.consent = 'privacy_api_unavailable'; render(); }
})();
